import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import axios from "../../../../components/Hooks/axios";
import Modal from "../../../../components/Modal/Modal";
import { setUserObject } from "../../../../redux/slices/authSlice";
import classes from "../Update Name/UpdateName.module.css";
import Verification from "../Verification/Verification";

import close from '../../../../assets/images/close.png'

const UpdateMobileNo = ({ onClose, mobile_number }) => {
	console.log(mobile_number);
	const { userId } = useSelector((state) => state.auth);
	const [verification, setVerification] = useState(false);
	const dispatch = useDispatch();
	const [btnDisable, setBtnDisable] = useState(false);
	const [content, setContent] = useState(mobile_number || "");

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 1024);
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const handelUpdateName = () => {
		// New validation: valid country code + space + exactly 10 digits
		const parts = content.trim().split(/\s+/);
		
		if (parts.length < 2) {
			return toast.error("Please provide a country code followed by a space (e.g., +91 1234567890)");
		}

		const countryCode = parts[0];
		const mobileNumber = parts[parts.length - 1];

		// Validate Country Code: Start with optional +, then 1-3 digits
		if (!/^\+?\d{1,3}$/.test(countryCode)) {
			return toast.error("Invalid Country Code! (e.g., +91 or 1)");
		}

		// Validate Mobile Number: Exactly 10 digits
		if (mobileNumber.length !== 10 || !/^\d{10}$/.test(mobileNumber)) {
			return toast.error("The mobile number after the space must be exactly 10 digits!");
		}
		
		setBtnDisable(true);

		const data = JSON.stringify({
			mobile_number: content,
		});

		axios
			.put(`/auth/update-user-details?userId=${userId}`, data, {
				headers: {
					"Content-Type": "application/json",
				},
			})
			.then(({ data }) => {
				toast.success(data.message);
				dispatch(setUserObject(data.user));
				setBtnDisable(false);
				onClose(false);
			})
			.catch((response) => {
				console.log(response);
				setBtnDisable(false);
			});
	};

	return (
		<Modal onClose={onClose}>
			{verification && <Verification onClose={setVerification} />}
			<div className={classes.overlay} onClick={(e) => e.stopPropagation()}>
				<div className={classes.form}>
					<h2>
						Update Mobile No
						{!isMobile &&
							<div className={classes.BackButton}>
								<img src={close} alt="" onClick={onClose} />
							</div>
						}
					</h2>
					<p>Please enter your new mobile number which you want to update and use</p>
					<label htmlFor="mobile-no">New Mobile Number</label>
					<input
						type="text"
						placeholder="+91 12345 67890"
						value={content}
						onChange={(e) => setContent(e.target.value)}
					/>
					<div className={classes.actions}>
						<button className={classes.btn} disabled={btnDisable} onClick={handelUpdateName}>
							Update
						</button>
						<button className={classes.link} onClick={() => onClose(false)}>
							Back
						</button>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default UpdateMobileNo;


